import {JSEncrypt} from "jsencrypt";
import React from "react";

export const encrypt = async (password, publicKey) => {
    const encryptor = new JSEncrypt();
    encryptor.setPublicKey(publicKey);
    return encryptor.encrypt(password);
};

export const validPasswordFormat = (password) => {
    if (!password.match(/^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[!@#$%^&*()_+\-=[\]{};':"\\|,.<>/?]).{8,}$/)) {
        return (
            <ul style={{color: 'black', textAlign: 'left'}}> {/* Set color to black and textAlign to left */}
                <li>Password must contain at least one special character</li>
                <li>Password must contain at least one number</li>
                <li>Password must contain at least one upper case letter</li>
                <li>Password must contain at least one lower case letter</li>
                <li>Password must be at least 8 characters long</li>
            </ul>
        );
    }
    return null;
};